var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 238.866h-112.467c-8.284 0-15-6.716-15-15v-144.6c0-8.284 6.716-15 15-15h112.467c8.284 0 15 6.716 15 15v144.6c0 8.284-6.716 15-15 15z",
    fill: "#fd7359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m464.867 238.866h-224.934c-8.284 0-15-6.716-15-15 0-28.401 11.881-47.411 22.364-64.183 9.553-15.285 17.803-28.485 17.803-48.283 0-8.284 6.716-15 15-15h144.6c8.284 0 15 6.716 15 15 0 19.798 8.25 32.998 17.803 48.283 10.482 16.771 22.363 35.781 22.363 64.183.001 8.284-6.715 15-14.999 15z",
    fill: "#e8fbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.867 223.866c0-28.401-11.881-47.411-22.363-64.183-9.554-15.285-17.804-28.485-17.804-48.283 0-8.284-6.716-15-15-15h-72.3v142.466h112.467c8.284 0 15-6.716 15-15z",
    fill: "#bbebfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.667 238.866h-128.534c-8.284 0-15-6.716-15-15v-64.266c0-31.88 12.643-47.364 21.874-58.67 7.114-8.713 10.259-12.933 10.259-21.663v-64.267c0-8.284 6.716-15 15-15h64.267c8.284 0 15 6.716 15 15v64.267c0 8.73 3.145 12.95 10.259 21.663 9.231 11.306 21.874 26.79 21.874 58.67v64.267c.001 8.283-6.715 14.999-14.999 14.999z",
    fill: "#8de624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.8 126.4h-192.8c-8.284 0-15-6.716-15-15v-64.266c0-8.284 6.716-15 15-15h192.8c8.284 0 15 6.716 15 15v64.266c0 8.285-6.716 15-15 15z",
    fill: "#00495b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.533 79.267v-64.267c0-8.284-6.716-15-15-15h-32.133v238.866h64.267c8.284 0 15-6.716 15-15v-64.266c0-31.88-12.643-47.364-21.874-58.67-7.115-8.713-10.26-12.933-10.26-21.663z",
    fill: "#00d836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m463.8 111.4v-64.266c0-8.284-6.716-15-15-15h-96.4v94.266h96.4c8.284 0 15-6.715 15-15z",
    fill: "#002731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m480.933 512h-449.866c-8.284 0-15-6.716-15-15v-192.8c0-8.284 6.716-15 15-15h449.866c8.284 0 15 6.716 15 15v192.8c0 8.284-6.716 15-15 15z",
    fill: "#ffe05b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m495.933 497v-192.8c0-8.284-6.716-15-15-15h-224.933v222.8h224.933c8.284 0 15-6.716 15-15z",
    fill: "#ffc347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497 319.2h-482c-8.284 0-15-6.716-15-15v-80.334c0-8.284 6.716-15 15-15h482c8.284 0 15 6.716 15 15v80.334c0 8.284-6.716 15-15 15z",
    fill: "#00c6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427.273 389.993-32.133-32.133c-5.857-5.857-15.355-5.857-21.213 0l-32.133 32.133c-5.858 5.857-5.858 15.355 0 21.213 5.859 5.858 15.355 5.858 21.213 0l6.527-6.527v28.054c0 8.284 6.716 15 15 15s15-6.716 15-15v-28.054l6.527 6.527c5.858 5.858 15.354 5.858 21.213 0 5.857-5.857 5.857-15.355-.001-21.213z",
    fill: "#002731"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#00f2ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 299.054-20.146 20.146h20.146z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.254 208.866-109.875 109.876c1.162.289 2.37.458 3.621.458h38.346l110.334-110.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 223.866v36.214l51.213-51.214h-36.213c-8.284 0-15 6.716-15 15z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#009bf2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m500.621 209.325-109.875 109.875h70.041l51.213-51.213v-44.12c0-7.034-4.847-12.92-11.379-14.542z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.187 208.866h-70.041l-20.146 20.147v70.041z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458.654 208.866h-70.041l-110.334 110.334h70.041z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m256 208.866h-22.279l-110.334 110.334h42.426l90.187-90.188z",
    fill: "#00f2ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductPerformance);
export default __webpack_public_path__ + "static/media/productPerformance.bd86a9e4a5f69485428fafa24b654033.svg";
export { ForwardRef as ReactComponent };